import React, { Component } from 'react';
import lodash from 'lodash';

import FileUploader from 'common/util/FileUploader';
import { trackEvent } from 'components/common/GoogleAnalytics/GoogleAnalytics';

import styles from './DragAndDrop.scss';

export default class DragAndDrop extends Component {
    constructor() {
        super();
        this.state = {
            dragCount: 0
        };
    }

    initDragAndDrop() {
        const draggableContainer = document.getElementById('draggableContainer');
        const canDragAndDrop = (('draggable' in draggableContainer) ||
        ('ondragstart' in draggableContainer && 'ondrop' in draggableContainer) &&
        'FormData' in window && 'FileReader' in window);
        if (!canDragAndDrop) {
            return;
        }

        draggableContainer.ondrag = function onDrag(e) {
            e.preventDefault();
            e.stopPropagation();
        };

        draggableContainer.ondragstart = function onDragStart(e) {
            e.preventDefault();
            e.stopPropagation();
        };

        draggableContainer.ondragend = function onDragEnd(e) {
            e.preventDefault();
            e.stopPropagation();
        };

        draggableContainer.ondragover = function onDragOver(e) {
            e.preventDefault();
            e.stopPropagation();
        };

        draggableContainer.ondragenter = e => {
            e.preventDefault();
            e.stopPropagation();
            this.setDragState.call(this, this.state.dragCount + 1);
        };

        draggableContainer.ondragleave = e => {
            e.preventDefault();
            e.stopPropagation();
            this.setDragState.call(this, this.state.dragCount - 1);
        };

        draggableContainer.ondrop = e => {
            e.preventDefault();
            e.stopPropagation();
            this.setDragState.call(this, 0);

            if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                this.handleFileSelectedEvent(e);
            }
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { dragCount } = this.state;
        const enterHoverState = dragCount === 1 && nextState.dragCount === 2;
        const leaveHoverState = dragCount === 2 && nextState.dragCount === 1;
        if(enterHoverState || leaveHoverState) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.initDragAndDrop();
    }

    setDragState(dragCount) {
        this.setState({dragCount});
    }

    handleFileSelectedEvent(e) {
        let files;
        if (e.dataTransfer) {
            files = lodash.toArray(e.dataTransfer.files);
        }
        else {
            files = lodash.toArray(e.target.files);
        }

        this.uploadFiles(files);
        this.trackEvent('Files dropped', files.length);
    }

    uploadFiles(files) {
        const {allowedMimeTypes, fileExtensionLookup, binderId, institutionId, store} = this.props;
        const fileUploader = new FileUploader({
            binderId,
            institutionId,
            fileExtensionLookup,
            allowedMimeTypes,
            store
        });
        fileUploader.uploadFiles(files);
    }

    trackEvent(action, value){
        const category = 'Drag and Drop';
        trackEvent({
            category,
            action,
            value,
        });
    }

    render() {
        const dragStyle = this.state.dragCount > 0 ? styles.draggableContainer__body : styles.hidden;

        return (
            <div id="draggableContainer" className={styles.draggableContainer} data-cy="DragAndDrop">
                {this.props.children}
                <div className={dragStyle}>
                    <div className={styles.draggableContainer__active}>
                        <span className={styles.uploadText}>Drop Files</span>
                        <i className={styles.uploadIcon}>cloud_upload</i>
                    </div>
                </div>
            </div>
        );
    }
}
